require('./bootstrap');
require('tinymce');
require('tinymce/plugins/charmap')
require('tinymce/themes/silver')
require('tinymce/icons/default')
require('alpinejs');

